// Property Fields

// ----------------------------------------------------------------
// Import image assets for the ICONS array
// ----------------------------------------------------------------
import EmotionIcon from './assets/instrument_icons/Emotion.png'
import HealthIcon from './assets/instrument_icons/Health.png'
import SleepIcon from './assets/instrument_icons/Sleep.png'
import CelebrateIcon from './assets/instrument_icons/Celebrate.png'
import SocialIcon from './assets/instrument_icons/Social.png'
import PersonalityIcon from './assets/instrument_icons/Personality.png'
import GeneralIcon from './assets/instrument_icons/General.png'
import ClinicalIcon from './assets/instrument_icons/Clinical.png'
import CognitiveIcon from './assets/instrument_icons/Cognitive.png'
import EnvironmentIcon from './assets/instrument_icons/Environment.png'
import CommunityIcon from './assets/instrument_icons/Community.png'
import DevelopmentIcon from './assets/instrument_icons/Development.png'
import FinancialIcon from './assets/instrument_icons/Financial.png'
import PsychiatryIcon from './assets/instrument_icons/Psychiatry.png'
import DecisionMakingIcon from './assets/instrument_icons/Decision Making.png'
import MotivationIcon from './assets/instrument_icons/Motivation.png'
import BehaviorIcon from './assets/instrument_icons/Behavior.png'
import LifeHistoryIcon from './assets/instrument_icons/Life History.png'

export const PROPERTIES = {
  display_name: {
    text: 'Display Name',
    type: 'input',
    description:
      'The lead-in, or text, display to participants before they begin the survey.',
    required: true
  },
  display_icon: {
    text: 'Display Icon',
    description: 'The icon that will be displayed when instrument is selected.',
    required: true
  },
  gamification_points: {
    text: 'Gamification Points',
    type: 'number',
    description:
      'How many in-app points will this instrument be worth to the participant upon completion.'
  },
  est_duration: {
    text: 'Duration',
    description: 'The estimated length of the survey.',
    type: 'radio',
    options: [
      {
        key: 'short',
        text: 'Short'
      },
      {
        key: 'medium',
        text: 'Medium'
      },
      {
        key: 'long',
        text: 'Long'
      }
    ],
    required: true
  },
  priority: {
    text: 'Priority (Higher is more important)',
    type: 'number',
    description:
      'How important is this instrument for our data set? ' +
      'High priority instruments may also be associated with high levels of gamification points.'
  },
  attribution_text: {
    text: 'Text for Attribution',
    type: 'textarea',
    description: `When we acquire a license there is a good chance that they will want us to give a
      citation of the source, or their organization, somewhere in our data. This would be where we put that.`
  },
  start: {
    text: 'Start'
  },
  finish: {
    text: 'Finish'
  },
  repeat: {
    text: 'Repeat'
  },
  visible: {
    text: 'Visible'
  },
  participants: {
    text: 'Participants'
  }
}

export const ICONS = [
  {
    key: 'Emotion',
    text: 'Emotion',
    icon: EmotionIcon
  },
  {
    key: 'Health',
    text: 'Health',
    icon: HealthIcon
  },
  {
    key: 'Sleep',
    text: 'Sleep',
    icon: SleepIcon
  },
  {
    key: 'Celebrate',
    text: 'Celebrate',
    icon: CelebrateIcon
  },
  {
    key: 'Social',
    text: 'Social',
    icon: SocialIcon
  },
  {
    key: 'Personality',
    text: 'Personality',
    icon: PersonalityIcon
  },
  {
    key: 'General',
    text: 'General',
    icon: GeneralIcon
  },
  {
    key: 'Clinical Card',
    text: 'Clinical',
    icon: ClinicalIcon
  },
  {
    key: 'Cognitive',
    text: 'Cognitive',
    icon: CognitiveIcon
  },
  {
    key: 'Environment',
    text: 'Environment',
    icon: EnvironmentIcon
  },
  {
    key: 'Community',
    text: 'Community',
    icon: CommunityIcon
  },
  {
    key: 'Development',
    text: 'Development',
    icon: DevelopmentIcon
  },
  {
    key: 'Financial',
    text: 'Financial',
    icon: FinancialIcon
  },
  {
    key: 'Psychiatry',
    text: 'Psychiatry',
    icon: PsychiatryIcon
  },
  {
    key: 'Decision Making',
    text: 'Decision Making',
    icon: DecisionMakingIcon
  },
  {
    key: 'Motivation',
    text: 'Motivation',
    icon: MotivationIcon
  },
  {
    key: 'Behavior',
    text: 'Behavior',
    icon: BehaviorIcon
  },
  {
    key: 'Life History',
    text: 'Life History',
    icon: LifeHistoryIcon
  }
]

export const _getDefaultMetadata = (instrumentType, displayName) => {
  const metadata = {
    schedule: {
      cohort: {
        type: 'all_users'
      },
      expire: {
        never: null
      },
      deploy: {
        now: null
      }
    },
    gamification_points: 10,
    visibility: 'all_day',
    visibilityRanges: [{ start: null, end: null }],
    priority: 5,
    est_duration: 'medium'
  }
  if (instrumentType === 'SURVEY') {
    metadata.display_icon = 'General'
    metadata.display_name = displayName
  }
  return metadata
}
